import React, { useContext, useEffect, useState } from 'react';

import CountriesChartContainer from 'Components/global/Page/Vaccination/Countries/index';
import IndiaStateCartogram from '@reuters-graphics/chart-module-india-covid-cartogram';
import Legend from './Legend';
import { LocaleContext } from 'Components/hooks/context';
import NoteBox from 'Components/common/NoteBox';
import SmartText from '@reuters-graphics/react-smart-text';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import debounce from 'lodash/debounce';
import fetchJson from 'Utils/fetchJson';

const chart = new IndiaStateCartogram();

const India = (props) => {
  const { content } = props;
  const [data, setData] = useState(null);
  const [parameter, setParameter] = useState('cases');
  const [uniformScale, setUniformScale] = useState(false);

  const locale = useContext(LocaleContext);

  const chartContainer = React.createRef();

  const resize = debounce(() => {
    chart.draw();
  }, 250);

  useEffect(() => {
    const fetchData = async() => {
      const data = await fetchJson('https://graphics.thomsonreuters.com/data/2021/covid-india-states/timeseries-cases-deaths.json');
      setData(data);
    };
    fetchData();
  }, []);

  // Draw chart
  useEffect(() => {
    if (!data) return;
    console.log(data);

    chart
      .selection(chartContainer.current)
      .props({
        locale,
        cat: parameter,
        scaleType: uniformScale ? 'uniform' : 'adjusted',
      })
      .data(data)
      .draw();
  }, [chartContainer, data, parameter, locale, uniformScale]);

  // Resize chart
  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [resize]);

  return (
    <>
      <section>
        <h4>{content.title}</h4>
      </section>
      <section>
        <NoteBox
          title='You need to know'
          source={'COVID-19 infections and deaths numbers at this level are sensitive to many reporting issues that may cause underreporting such as the availability of wide-spread testing and differences in the health care infrastructure between regions.'}
        />
      </section>
      <section className={classnames(component, 'wide')}>
        <section className='options-container clearfix'>
          <div className='options'>
            <button
              className={parameter === 'cases' ? 'active' : ''}
              onClick={() => setParameter('cases')}
            >{content.cases}
            </button>
            <button
              className={parameter === 'deaths' ? 'active' : ''}
              onClick={() => setParameter('deaths')}
            >{content.deaths}
            </button>
          </div>
          <div className='options'>
            <button
              className={uniformScale ? '' : 'active'}
              onClick={() => setUniformScale(false)}
            >{content.adjusted}
            </button>
            <button
              className={uniformScale ? 'active' : ''}
              onClick={() => setUniformScale(true)}
            >{content.uniform}
            </button>

          </div>
        </section>
        <Legend content={content} />
        <div className='india-states-cartogram' ref={chartContainer} />
        <div className='data-source'>
          <SmartText source={content.source} wrap />
        </div>
      </section>
    </>
  );
};

export default India;
